<template>
  <div
    class="border rounded shadow-lg border-gray-700/25 w-full h-full pt-2 flex flex-col justify-start items-center"
  >
    <span class="font-londrina block mx-auto text-indigo-light text-2xl mb-2">
      {{ label }}:
    </span>
    <div
      :class="`w-full h-full flex items-center relative ${
        isRevealed || won ? '' : 'cursor-pointer'
      }`"
      @click="reveal"
    >
      <transition name="fade">
        <div
          v-if="!isRevealed"
          :class="`w-full h-full absolute bg-gray-800 rounded transition duration-1000 text-gray-200 text-xs md:text-sm text-center flex justify-center items-center ${
            won && !isRevealed ? 'opacity-40 text-opacity-0' : 'text-opacity-30'
          }`"
        >
          Click to reveal
        </div>
      </transition>
      <span
        :class="`block text-indigo-50 font-bold font-sans mx-auto px-6 pb-4 ${
          short ? 'text-lg md:text-2xl' : 'text-sm md:text-lg'
        }`"
      >
        <slot :obscure="obscure"></slot>
      </span>
      <transition name="drop">
        <div
          class="absolute top-0 right-0 -mt-2 -mr-2 w-6 h-6 rotate-12 bg-yellow-400 rounded-full flex justify-center items-center text-xs font-londrina transform"
          v-if="!isRevealed"
        >
          {{ bonus }}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'isRevealed',
    event: 'reveal',
  },
  props: {
    label: { type: String, required: true },
    isRevealed: { type: Boolean, required: true },
    short: { type: Boolean, required: false, default: false },
    won: { type: Boolean, required: false, default: false },
    bonus: { type: Number, required: false, default: 30 },
  },
  methods: {
    reveal(ev) {
      if (!this.won) {
        this.$emit('reveal', true);
      }
    },
    obscure(text) {
      if (!text) {
        return '';
      }
      return text
        .split('')
        .map((ch) => (ch !== ' ' ? 'x' : ' '))
        .join('');
    },
  },
};
</script>

<style lang="postcss">
.drop-leave-active {
  @apply opacity-0 translate-y-8;
  @apply transition duration-500 delay-100;
}
.fade-leave-active {
  @apply opacity-0 duration-1000 transition;
}
</style>
